import marketConfigs from './markets.json';

interface Keyable<T> {
  [key: string]: T;
}
interface MarketConfig {
  sp: string;
  oneweb?: boolean;
  features: Keyable<string | boolean>;
}

interface ConfigSearchProfile {
  market: string;
  locale: string;
  language: string;
}

export const config = marketConfigs as Keyable<MarketConfig>;

export function getSearchProfileByLocale(locale: string): string {
  return locale ? config[locale].sp : config.en_GB.sp;
}

export const getConfigBySearchProfile = (sp: string): ConfigSearchProfile => {
  const configMap = new Map();

  Object.entries(config).forEach(([index, value]) => {
    configMap.set(value.sp, {
      language: index.split('_')[0],
      market: index.split('_')[1],
      ...value,
    });
  });

  const marketConfig = configMap.get(sp);

  if (!marketConfig) {
    throw new Error(`No matching market config found with provided search profile "${sp}"`);
  }

  return {
    market: marketConfig.market,
    language: marketConfig.language,
    locale: `${marketConfig.language}_${marketConfig.market}`,
  };
};
